import React from 'react'
import { Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import PresentationCard from 'components/card/PresentationCard'
import { DATA_ADD_NEW_DATA, IMPORT_TYPE, IMPORT_TYPE_TRAITEMENT, STATION_INTEGRATION } from 'traitements/constants/TraitementConstants'
import { shallowEqual, useSelector } from 'react-redux'
import { trim } from 'lodash'
import meteofranceLogo from 'assets/pictures/logos/meteofrance.png'
import era5Logo from 'assets/pictures/logos/era5.png'
import pluvioempriseLogo from 'assets/pictures/logos/pluvioemprise.png'
import safranLogo from 'assets/pictures/logos/safran.png'


const AddPluvioStepStation = ({
    changeStation,
    nextStep,
    setFilters,
    setJobDataTypes,
    setChoices,
}) => {
    const {
        pluviometryDataTypes,
    } = useSelector(store => ({
        pluviometryDataTypes: store.PluviometryReducer.pluviometryDataTypes,
    }), shallowEqual)

    const getDefaultParams = (stationType) => {
        switch (stationType) {
            case IMPORT_TYPE.METEO_FRANCE:
                const definedDataType = pluviometryDataTypes.reduce((acc, dtt) => {
                    switch (trim(dtt?.label)) {
                        case i18n.rain: return { ...acc, rain: true, rainDt: dtt.id }
                        case i18n.radiation: return { ...acc, radiation: true, radiationDt: dtt.id }
                        case i18n.temperature: return { ...acc, temperature: true, temperatureDt: dtt.id }
                        case i18n.etpShort: return { ...acc, etp: true, etpDt: dtt.id }
                        default:
                            return acc
                    }
                }, {})
                return {
                    filters: definedDataType,
                    dataTypes: [STATION_INTEGRATION, DATA_ADD_NEW_DATA],
                }
            default:
                return { filters: {}, dataTypes: [] }
        }
    }

    const updateParams = (stationType) => {
        const params = getDefaultParams(stationType)
        setFilters(params.filters)
        setJobDataTypes(params.dataTypes)
    }

    const centerStyle = {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    }

    return (
        <Grid container justifyContent='center' alignItems='center' spacing={3} paddingTop={2}>
            <Grid size={6} >
                <PresentationCard
                    iconComponent={
                        <img
                            className='responsive-img'
                            src={meteofranceLogo}
                            height={70}
                            width={70}
                            style={{
                                textAlign: 'center',
                                display: 'table-cell',
                                verticalAlign: 'middle',
                            }}
                        />}
                    iconContainerStyle={centerStyle}
                    title={i18n.meteofrance}
                    onClick={() => {
                        setChoices(prev => ({
                            ...prev,
                            TYPE: `(${i18n.meteofrance})`,
                        }))
                        changeStation({ stationType: IMPORT_TYPE_TRAITEMENT.PLUVIO_PORTAIL })
                        updateParams(IMPORT_TYPE.PLUVIO_PORTAIL, setFilters, setJobDataTypes)
                        nextStep()
                    }}
                    description={i18n.meteoFranceDescription}
                />
            </Grid>
            <Grid size={6} >
                <PresentationCard
                    iconComponent={
                        <img
                            className='responsive-img'
                            src={era5Logo}
                            height={70}
                            width={70}
                            style={{
                                textAlign: 'center',
                                display: 'table-cell',
                                verticalAlign: 'middle',
                            }}
                        />}
                    iconContainerStyle={centerStyle}
                    title={i18n.ERA5}
                    onClick={() => {
                        setChoices(prev => ({
                            ...prev,
                            TYPE: `(${IMPORT_TYPE.ERA5})`,
                        }))
                        changeStation({ stationType: IMPORT_TYPE_TRAITEMENT.ERA5 })
                        updateParams(IMPORT_TYPE.ERA5, setFilters, setJobDataTypes)
                        nextStep()
                    }}
                    description={i18n.ERA5Description}
                />
            </Grid>
            <Grid size={6}>
                <PresentationCard
                    iconComponent={
                        <img
                            className='responsive-img'
                            src={pluvioempriseLogo}
                            height={70}
                            width={70}
                            style={{
                                textAlign: 'center',
                                display: 'table-cell',
                                verticalAlign: 'middle',
                            }}
                        />}
                    iconContainerStyle={centerStyle}
                    title={i18n.pluvioAreaJob}
                    onClick={() => {
                        setChoices(prev => ({
                            ...prev,
                            TYPE: `(${i18n.pluvioAreaJob})`,
                        }))
                        changeStation({ stationType: IMPORT_TYPE_TRAITEMENT.PLUVIO_EMPRISE })
                        updateParams(IMPORT_TYPE.PLUVIO_EMPRISE, setFilters, setJobDataTypes)
                        nextStep()
                    }}
                    description={i18n.pluvioAreaJobDescription}
                />
            </Grid>
            <Grid size={6}>
                <PresentationCard
                    iconComponent={
                        <img
                            className='responsive-img padding-right-1'
                            src={safranLogo}
                            width={110}
                        />
                    }
                    iconContainerStyle={centerStyle}
                    title={i18n.SAFRAN}
                    onClick={() => {
                        setChoices(prev => ({
                            ...prev,
                            TYPE: `(${i18n.SAFRAN})`,
                        }))
                        changeStation({ stationType: IMPORT_TYPE_TRAITEMENT.METEO_FRANCE_RADAR })
                        updateParams(IMPORT_TYPE.METEO_FRANCE_RADAR, setFilters, setJobDataTypes)
                        nextStep()
                    }}
                    description={i18n.SAFRANDescription}
                />
            </Grid>
        </Grid>
    )
}

AddPluvioStepStation.propTypes = {
    station: PropTypes.shape({
        code: PropTypes.string,
        stationType: PropTypes.string,
        name: PropTypes.string,
        jobExecutionId: PropTypes.number,
        job: PropTypes.shape({
            id: PropTypes.number,
        }),
        jobExecution: PropTypes.shape({
            statusCode: PropTypes.number,
        }),
        ids: PropTypes.arrayOf(PropTypes.number),
        nature: PropTypes.string,
    }),
    nextStep: PropTypes.func,
    changeStation: PropTypes.func,
    setFilters: PropTypes.func,
    setJobDataTypes: PropTypes.func,
    setChoices: PropTypes.func,
}

export default AddPluvioStepStation